import { render, staticRenderFns } from "./verifyCode.vue?vue&type=template&id=5136a286&scoped=true"
import script from "./verifyCode.vue?vue&type=script&lang=js"
export * from "./verifyCode.vue?vue&type=script&lang=js"
import style0 from "./verifyCode.vue?vue&type=style&index=0&id=5136a286&lang=scss"
import style1 from "./verifyCode.vue?vue&type=style&index=1&id=5136a286&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5136a286",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5136a286')) {
      api.createRecord('5136a286', component.options)
    } else {
      api.reload('5136a286', component.options)
    }
    module.hot.accept("./verifyCode.vue?vue&type=template&id=5136a286&scoped=true", function () {
      api.rerender('5136a286', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/verifyCode.vue"
export default component.exports